import type { SVGProps } from 'react';

function IconTaxi(props: SVGProps<SVGSVGElement>) {
    return (
        <svg viewBox="0 0 640 640" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M256 64C238.3 64 224 78.3 224 96L224 128L216.9 128C172.4 128 133.8 158.5 123.5 201.8L110 258.6C83.4 266.4 64 290.9 64 320L64 520C64 533.3 74.7 544 88 544C101.3 544 112 533.3 112 520L112 480L528 480L528 520C528 533.3 538.7 544 552 544C565.3 544 576 533.3 576 520L576 320C576 290.9 556.6 266.4 530 258.6L516.5 201.8C506.2 158.5 467.6 128 423.1 128L416 128L416 96C416 78.3 401.7 64 384 64L256 64zM170.2 212.9C175.3 191.3 194.7 176 216.9 176L423.2 176C445.4 176 464.7 191.3 469.9 212.9L480.2 256L160 256L170.3 212.9zM512 304C520.8 304 528 311.2 528 320L528 432L112 432L112 320C112 311.2 119.2 304 128 304L512 304zM208 368C208 350.3 193.7 336 176 336C158.3 336 144 350.3 144 368C144 385.7 158.3 400 176 400C193.7 400 208 385.7 208 368zM464 400C481.7 400 496 385.7 496 368C496 350.3 481.7 336 464 336C446.3 336 432 350.3 432 368C432 385.7 446.3 400 464 400z"
                fill="currentColor"
            />
        </svg>
    );
}

export default IconTaxi;
